module.exports = __webpack_public_path__ + "img/label-plein-bleu.svg";